<div class="col-lg-12 content-scroll-screen parent">
  <div class="row child">
    <p-card class="card-spacing-0">
      <span class="d-flex justify-content-between align-items-center m-3">
        <span class="col-auto d-flex align-items-center gap-3">
          <h2 class="mb-0">Project Access Groups</h2>
          @if (loading) {
            <jni-spinner></jni-spinner>
          }
        </span>
        <p-button
          label="Enable Selected"
          icon="pi pi-check"
          size="small"
          [disabled]="selectedClients.length === 0 || enablingSelected"
          [loading]="enablingSelected"
          (click)="enableSelected()" />
      </span>

      <div class="col-12">
        <p-table
          #dt
          [stripedRows]="true"
          [rowHover]="true"
          [showCurrentPageReport]="true"
          [scrollable]="clientGroups.length > 0"
          [scrollHeight]="
            clientGroups.length > 0 ? 'calc(100vh - 310px)' : undefined
          "
          [size]="'small'"
          [value]="clientGroups"
          [rows]="rows"
          [totalRecords]="totalRecords"
          [lazy]="true"
          dataKey="customerAccount"
          [(selection)]="selectedClients"
          (onLazyLoad)="loadData($event)"
          [showCurrentPageReport]="true"
          [rowsPerPageOptions]="[10, 25, 50]"
          [paginator]="clientGroups.length > 0"
          [filterDelay]="0"
          paginatorStyleClass="paginator-table"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
          [styleClass]="
            clientGroups.length > 0
              ? 'table-listing'
              : 'table-listing no-data-table'
          ">
          <ng-template pTemplate="header">
            <tr class="table-head">
              <th class="checkbox-col">
                <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
              </th>
              <th class="number" pSortableColumn="customerAccount">
                Number
                <p-sortIcon field="customerAccount"></p-sortIcon>
              </th>
              <th class="client-id" pSortableColumn="clientName">
                Client Name
                <p-sortIcon field="clientName"></p-sortIcon>
              </th>
              <th class="groups" pSortableColumn="groupCount">
                Groups
                <p-sortIcon field="groupCount"></p-sortIcon>
              </th>
              <th class="enable-disable">Status</th>
            </tr>
            <tr class="sort-row">
              <th></th>
              <th>
                <input
                  pInputText
                  type="text"
                  autocomplete="off"
                  (input)="
                    dt.filter(
                      $any($event.target).value,
                      'customerAccount',
                      'contains'
                    )
                  "
                  (paste)="$event.stopPropagation()"
                  placeholder="search"
                  class="p-column-filter" />
              </th>
              <th>
                <input
                  pInputText
                  type="text"
                  autocomplete="off"
                  (input)="
                    dt.filter(
                      $any($event.target).value,
                      'clientName',
                      'contains'
                    )
                  "
                  (paste)="$event.stopPropagation()"
                  placeholder="search"
                  class="p-column-filter" />
              </th>
              <th></th>
              <th></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="loadingbody">
            <tr style="height: 46px">
              <td><p-skeleton></p-skeleton></td>
              <td><p-skeleton></p-skeleton></td>
              <td><p-skeleton></p-skeleton></td>
              <td><p-skeleton></p-skeleton></td>
              <td><p-skeleton></p-skeleton></td>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-item>
            <tr>
              <td>
                <p-tableCheckbox [value]="item"></p-tableCheckbox>
              </td>
              <td>
                <a
                  class="number-link"
                  href="javascript:void(0)"
                  (click)="
                    openDetailStacker(item.customerAccount, item.clientName)
                  "
                  >{{ item.customerAccount }}</a
                >
              </td>
              <td>{{ item.clientName }}</td>
              <td>
                <span class="group-badge"
                  >{{ item.groupCount }}
                  {{ item.groupCount === 1 ? "group" : "groups" }}</span
                >
              </td>
              <td>
                <p-toggleSwitch
                  [ngModel]="item.isEnabled"
                  (onChange)="onToggleEnable(item, $event.checked)"
                  ariaLabel="Toggle Client Portal access">
                </p-toggleSwitch>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr *ngIf="!loading">
              <td colspan="5" class="no-data-cell border-0">
                <div
                  class="d-flex align-items-center justify-content-center flex-column text-center h-100 w-100">
                  <span class="no-data-image d-block w-25 h-25 mb-4"></span>
                  <h3 class="fw-medium fs-5 mb-2">No Data found</h3>
                  <p>
                    It seems we couldn't locate any information at this time.<br />
                    Please check back later or try a different search.
                  </p>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </p-card>
  </div>
</div>

<jni-modal-stacker
  class="modal-header-sticky"
  *ngIf="showDetailStacker"
  [displayModal]="showDetailStacker"
  (closeEvent)="closeDetailStacker()">
  <div class="panelBody">
    <jni-client-group-detail
      [clientIdInput]="selectedClientId"
      [clientNameInput]="selectedClientName"
      (closeModalEvent)="closeDetailStacker()">
    </jni-client-group-detail>
  </div>
</jni-modal-stacker>
